
import { computed, defineComponent } from 'vue'
import MarkdownIt from 'markdown-it'

export default defineComponent({
  props: {
    content: {
      type: String,
      required: false,
      default: '',
    },
  },
  components: {},
  setup(props) {
    const md = new MarkdownIt()
    const contentToHtml = computed(() => {
      return md.render(props.content)
    })
    return {
      contentToHtml,
    }
  },
})
